import createStory from './createStory';

const title = "Chia Seed Tips"
const shortName="chiaTips"
const preview="We eat chia seeds every single morning - these are our biggest tips"

const element0 = <p className="storyBodyText"> coming soon! </p>

const story = [element0]
const chiaTips = createStory (shortName, title, preview, story)

export default chiaTips;